export const RELEASE_DETAILS:  any = {'releaseNumber': 'production_2.0.6','releaseDate': 'Thursday, 12 December 2024 at 12:33'};